import React from "react";

const Section3 = () => {
  return (
    <div
      className=" bg-black bg-no-repeat bg-center bg-cover text-white font-montserrat "
      style={{ backgroundImage: "url(../assets/bg/bg5.svg)" }}
    >
      <div className=" bg-white/5 h-full py-20 ">
        <div className=" relative ">
          <div className="absolute z-0 left-0 right-0 w-[25%] mx-auto h-5 blur-2xl rounded-full bg-white"></div>
          <p className=" text-3xl font-bold text-center">Our solutions</p>
        </div>
        <div className=" lg:w-[85%] w-[95%] mx-auto text-[#F6F4EE] flex sm:flex-row flex-col items-center gap-5 lg:gap-5 mt-14 ">
          <div className="sm:w-1/4 w-[90%] mx-auto h-[25rem] rounded-2xl flex flex-col justify-center  grid content-between border-2 border-[#856E4F] bg-gradient-to-b from-[#856E4F47] to-[#F6FFE900] p-5 backdrop-blur-md">
            <p className="xl:text-2xl md:text-xl font-bold text-center">
            Custom Gas Fee Mechanism
            </p>
            <div className="py-5 flex justify-center">
              <img src="../assets/other/market.svg" className="lg:h-32 h-24" />
            </div>
            <div>
              <ul className=" list-disc flex flex-col gap-1 xl:text-base text-sm font-medium text-[#F6F4EE]">
                <li>Transactions processed with fees directly in USDT, eliminating reliance on native blockchain tokens</li>
              </ul>
            </div>
          </div>
          <div className="sm:w-1/4 w-[90%] mx-auto h-[25rem] rounded-2xl flex flex-col justify-center  grid content-between border-2 border-[#856E4F] bg-gradient-to-b from-[#856E4F47] to-[#F6FFE900] p-5 backdrop-blur-md">
            <p className="xl:text-2xl md:text-xl font-bold text-center">
            Liquidity Pool Management
            </p>
            <div className="py-5 flex justify-center">
              <img src="../assets/other/vortex.svg" className="lg:h-36 h-28" />
            </div>
            <div>
              <ul className="xl:w-[85%] w-[95%] mx-auto list-disc flex flex-col gap-1 xl:text-base text-sm font-medium text-[#F6F4EE]">
                <li>Seamless liquidity provisioning for stablecoin transfers across the Avalanche Subnet.</li>
              </ul>
            </div>
          </div>
          <div className="sm:w-1/4 w-[90%] mx-auto h-[25rem] rounded-2xl flex flex-col justify-center  grid content-between border-2 border-[#856E4F] bg-gradient-to-b from-[#856E4F47] to-[#F6FFE900] p-5 backdrop-blur-md">
            <p className="xl:text-2xl md:text-xl font-bold text-center">
            Scalable Blockchain Infrastructure
            </p>
            <div className=" py-5 flex justify-center">
              <img src="../assets/other/advise.svg" className="lg:h-36 h-28" />
            </div>
            <div>
              <ul className="xl:w-[90%] w-[95%] mx-auto  list-disc flex flex-col gap-1  xl:text-base text-sm font-medium text-[#F6F4EE]">
                <li>Built on the Avalanche Subnet to ensure fast, low-latency transactions with high throughput.</li>
              </ul>
            </div>
          </div>
          <div className="sm:w-1/4 w-[90%] mx-auto h-[25rem] rounded-2xl flex flex-col justify-center  grid content-between border-2 border-[#856E4F] bg-gradient-to-b from-[#856E4F47] to-[#F6FFE900] p-5 backdrop-blur-md">
            <p className="xl:text-2xl md:text-xl font-bold text-center">
            Cross-Chain Interoperability
            </p>
            <div className=" py-5 flex justify-center">
              <img src="../assets/other/advise.svg" className="lg:h-36 h-28" />
            </div>
            <div>
              <ul className="xl:w-[90%] w-[95%] mx-auto  list-disc flex flex-col gap-1  xl:text-base text-sm font-medium text-[#F6F4EE]">
                <li>Enhanced flexibility with support for stablecoin transfers across multiple blockchain networks.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
